<template>
  <div class="gh-form gh-form--newsletter-inline">
    <div class="gh-form__wrapper">
      <transition enterActiveClass="animated fadeIn" leaveActiveClass="animated zoomOut" mode="out-in">
        <div class="gh-form__response" v-if="subscribed">
          <el-alert
              title="Thank you for subscribing!"
              type="success"
              showIcon
              description="We sent you an email with a few welcome gifts. Please check your inbox and junk/other folders."
              :closable="false">
          </el-alert>
        </div>
        <el-form
            v-else
            :model="form"
            :rules="form.validationRules"
            @keyup.enter.native="attemptSubmit('elForm')"
            ref="elForm"
            class="gh-form__content">
          <div class="gh-form__group">
            <el-form-item prop="fullName" class="gh-form__item">
              <div class="gh-nl-field">
                <img class="gh-nl-field__icon" src="/images/app/newsletter/first-name.svg" width="18" height="18" alt="" loading="lazy">
                <el-input class="gh-form__input" v-model="form.fullName" placeholder="First Name" name="name"></el-input>
              </div>
            </el-form-item>

            <el-form-item prop="email" class="gh-form__item">
              <div class="gh-nl-field">
                <img class="gh-nl-field__icon" src="/images/app/newsletter/email.svg" width="18" height="18" alt="" loading="lazy">
                <el-input class="gh-form__input" type="email" v-model="form.email" placeholder="Email Address" name="email"></el-input>
              </div>
            </el-form-item>

            <el-form-item prop="professionId" class="gh-form__item gh-form__item--profession">
              <div class="gh-nl-field">
                <img class="gh-nl-field__icon" src="/images/app/newsletter/profession.svg" width="18" height="18" alt="" loading="lazy">
                <gh-profession-selector placeholder="Profession" @change="changeProfession"/>
              </div>
            </el-form-item>
          </div>

          <vue-recaptcha
              ref="recaptcha"
              :sitekey="recaptchaSitekey"
              size="invisible"
              badge="bottomleft"
              :loadRecaptchaScript="true"
              @verify="setRecaptchaToken"/>

          <div class="gh-form__actions">
            <el-button
                class="gh-button--newsletter-join"
                @click="attemptSubmit('elForm')" :loading="form.processing" :disabled="form.processing">
              {{ computedSubmitButtonLabel }}
            </el-button>
          </div>
        </el-form>
      </transition>
    </div>
  </div>
</template>

<script>
import formMixin from '@/modules/form/mixins/form'
import recaptcha from '@/modules/form/mixins/recaptcha'
import Form from '@/modules/form/models/Form'
import ghProfessionSelector from '@/modules/profession/components/ProfessionSelector'

export default {
  mixins: [
    formMixin,
    recaptcha
  ],

  components: {
    ghProfessionSelector
  },

  data() {
    return {
      // `fullName`, not AUS's `firstName`: GuestSubscribeRequest and
      // GuestController on this repo read fullName off the payload.
      form: new Form({
        email: '',
        fullName: '',
        professionId: '',
        recaptcha: ''
      }),
      submitButtonLabel: 'Join',
      subscribed: false
    }
  },

  methods: {
    attemptSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.scrollToError(formName)
          return false
        }

        this.requestRecaptchaToken()
      })
    },

    setRecaptchaToken(token) {
      this.form.recaptcha = token

      this.form.post('/api/v1/newsletter/guest', {
        mhaUrl: location.pathname,
      })
          .then(_ => this.subscribed = true)
          .catch(({data}) => {
            this.formFailure(data)
          })
    },

    changeProfession(profession) {
      this.form.professionId = profession
    },
  }
}
</script>
